import { LibraryPhoto } from "../../PhotoManager/API/api";

export interface PhotoDateRange {
  minDate: Date;
  maxDate: Date;
}

const MONTH_NAMES_SHORT = [
  "Jan", "Feb", "Mar", "Apr", "May", "Jun",
  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
];

export const formatDateDisplay = (dateString: string): string => {
  const parts = dateString.split("-");
  if (parts.length !== 3) return dateString;

  const [year, month, day] = parts.map(Number);

  if (!Number.isFinite(year) || !Number.isFinite(month) || !Number.isFinite(day)) {
    return dateString;
  }

  if (month < 1 || month > 12) return dateString;

  const monthName = MONTH_NAMES_SHORT[month - 1];
  return `${String(day).padStart(2, "0")} ${monthName} ${year}`;
};

export const formatDateRangeDisplay = (
  startDate: string | null,
  endDate: string | null
): string => {
  if (!startDate) return "";
  const formattedStart = formatDateDisplay(startDate);
  if (endDate && endDate !== startDate) {
    const formattedEnd = formatDateDisplay(endDate);
    return `${formattedStart} → ${formattedEnd}`;
  }
  return formattedStart;
};

export const calculatePhotoDateRange = (
  photos: LibraryPhoto[]
): PhotoDateRange | null => {
  if (photos.length === 0) return null;

  let minTimestamp = Infinity;
  let maxTimestamp = -Infinity;
  let photosWithDates = 0;

  for (const photo of photos) {
    if (!photo.dateTimeTaken) continue;

    const timestamp = new Date(photo.dateTimeTaken).getTime();
    if (isNaN(timestamp)) continue;

    photosWithDates++;
    if (timestamp < minTimestamp) minTimestamp = timestamp;
    if (timestamp > maxTimestamp) maxTimestamp = timestamp;
  }

  // Only return date range if ALL photos have valid dates
  if (photosWithDates === 0 || photosWithDates < photos.length) {
    return null;
  }

  return {
    minDate: new Date(minTimestamp),
    maxDate: new Date(maxTimestamp)
  };
};
